module.exports = __webpack_public_path__ + "img/title.e28243fa.png";